const getBaseUrl = (): string => {
  return import.meta.env.VITE_UI_BASE_URL || '/';
};

export function assetPath(path: string): string {
  const baseUrl = getBaseUrl();
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  const fullPath = baseUrl.endsWith('/') ? `${baseUrl}${cleanPath}` : `${baseUrl}/${cleanPath}`;

  return fullPath;
}

export const ASSET_PATHS = {
  APPLICATION_ICON: assetPath('application-icon.svg'),
  BLUE_WAVES_LINES: assetPath('blue-waves-lines.svg'),
  CLOSE_ICON: assetPath('close-icon.svg'),
  CMS_LOGO: assetPath('cms-logo.svg'),
  CSV_FILE_ICON: assetPath('csv-file-icon.svg'),
  ENTER_ICON: assetPath('enter-icon.svg'),
  ERROR_ICON: assetPath('error-icon.svg'),
  EXCEL_FILE_ICON: assetPath('excel-file-icon.svg'),
  EXIT_ICON: assetPath('exit-icon.svg'),
  EYE_ICON: assetPath('eye-icon.svg'),
  EYE_OFF_ICON: assetPath('eye-off-icon.svg'),
  FILE_UPLOAD_ICON: assetPath('file-upload-icon.svg'),
  FOLDER_OPEN_ICON: assetPath('folder-open-icon.svg'),
  GENERIC_FILE_ICON: assetPath('generic-file-icon.svg'),
  HAMBURGER_MENU_ICON: assetPath('hamburger-menu-icon.svg'),
  HAMBURGER_MENU_ICON_INACTIVE: assetPath('hamburger-menu-inactive-icon.svg'),
  HHS_LOGO: assetPath('hhs-logo.svg'),
  HOME_ICON: assetPath('home-icon.svg'),
  HOME_INACTIVE_ICON: assetPath('home-inactive-icon.svg'),
  INFO_CIRCLE_ICON: assetPath('info-circle-icon.svg'),
  INFO_CIRCLE_INVERTED_ICON: assetPath('info-circle-inverted-icon.svg'),
  JPG_FILE_ICON: assetPath('jpg-file-icon.svg'),
  LANDING_PAGE_GRAPHIC: assetPath('landing-page-graphic.svg'),
  LOCATION_ICON: assetPath('location-icon.svg'),
  MANAGE_APPROVALS_ICON: assetPath('manage-approvals-icon.svg'),
  MANAGE_CONTRACTS_ICON: assetPath('manage-contracts-icon.svg'),
  MOVE_USER_ICON: assetPath('move-user-icon.svg'),
  MY_CMS_APPS_ICON: assetPath('my-cms-apps-icon.svg'),
  PDF_FILE_ICON: assetPath('pdf-file-icon.svg'),
  PNG_FILE_ICON: assetPath('png-file-icon.svg'),
  QUESTION_MARK_ICON: assetPath('question-mark-icon.svg'),
  RESEND_ICON: assetPath('resend-icon.svg'),
  RETRY_ERROR_ICON: assetPath('retry-error-icon.svg'),
  RETURNED_ICON: assetPath('returned-icon.svg'),
  SUCCESS_ICON: assetPath('success-icon.svg'),
  TRASHCAN_ICON: assetPath('trashcan-icon.svg'),
  USER_AVATAR_ICON: assetPath('user-avatar-icon.svg'),
  USER_ICON: assetPath('user-icon.svg'),
  WARNING_ICON: assetPath('warning-icon.svg'),
  WORD_DOC_FILE_ICON: assetPath('word-doc-file-icon.svg'),
  X_ICON: assetPath('x-icon.svg'),
} as const;
